import React, {Component} from 'react';
import {injectIntl} from 'react-intl';

import {FormattedMessage} from 'components/FormattedComponents';
import Spinner from 'components/Spinner';

import messages from './messages';
import {
  StyledInfo,
  AcceptAllCookiesButton,
  SavePreferencesButton,
  ContentWrapper,
  Line,
  StyledListTitle,
  StyledItem,
  StyledLink,
  WrapperOptions,
  StyledRadioButton,
  StyledHeader,
  StyledListItem,
  EmptySection,
  CloseButton,
  HeaderWrapper,
  ListWrapper,
  StyledSpan,
  ButtonWrapper
} from './styles';

import {PRIVACY_POLICY_URL} from '../../constants';
import {COOKIE_PREFERENCE_OPTIONS} from '../../enums';

const {YES, NO} = COOKIE_PREFERENCE_OPTIONS;

class CookiePreferencesContent extends Component {
  render() {
    const {
      intl: {formatMessage},
      isMobile,
      acceptAllCookies,
      onClose,
      cookiePreference,
      setCookiePreferenceOption,
      savePreferences,
      goToPrivacyPage,
      savePreferenceButtonLoading,
      acceptAllCookiesButtonLoading,
      consentCookiesMutation
    } = this.props;

    const areActionsDisabled = acceptAllCookiesButtonLoading || savePreferenceButtonLoading;

    return (
      <ContentWrapper>
        <HeaderWrapper>
          <StyledHeader isMobile={isMobile}>{formatMessage(messages.cookiePreferences)}</StyledHeader>
          <CloseButton onClick={onClose} />
        </HeaderWrapper>
        <StyledInfo>{formatMessage(messages.useOfCookies)}</StyledInfo>
        <ButtonWrapper>
          <AcceptAllCookiesButton
            role="button"
            disabled={areActionsDisabled}
            onClick={() => acceptAllCookies(consentCookiesMutation)}
          >
            {acceptAllCookiesButtonLoading ? (
              <Spinner color="white" size="20px" centerAbs centerX centerY />
            ) : (
              formatMessage(messages.acceptAllCookies).toUpperCase()
            )}
          </AcceptAllCookiesButton>
        </ButtonWrapper>
        <Line />
        <EmptySection>
          <StyledListTitle>{formatMessage(messages.requiredCookies)}</StyledListTitle>
        </EmptySection>
        <StyledItem>{formatMessage(messages.firstForRequiredCookies)}</StyledItem>

        <ListWrapper>
          <StyledItem>{formatMessage(messages.useForRequiredCookies)}</StyledItem>
          <StyledListItem>
            <StyledSpan>{formatMessage(messages.recognizeAuthentication)}</StyledSpan>
          </StyledListItem>
          <StyledListItem>
            <StyledSpan>{formatMessage(messages.preventFraudulentActivity)}</StyledSpan>
          </StyledListItem>
          <StyledListItem>
            <StyledSpan>{formatMessage(messages.improveSafety)}</StyledSpan>
          </StyledListItem>
          <StyledListItem>
            <StyledSpan>{formatMessage(messages.track)}</StyledSpan>
          </StyledListItem>
          <StyledListItem>
            <StyledSpan>{formatMessage(messages.customerSupportService)}</StyledSpan>
          </StyledListItem>
        </ListWrapper>
        <Line />

        <HeaderWrapper>
          <StyledListTitle>{formatMessage(messages.otherCookies)}</StyledListTitle>
          <WrapperOptions>
            <StyledRadioButton
              disabled={areActionsDisabled}
              caption={formatMessage(messages.on)}
              checked={cookiePreference !== NO}
              onChange={() => setCookiePreferenceOption(YES)}
            />
            <StyledRadioButton
              disabled={areActionsDisabled}
              caption={formatMessage(messages.off)}
              checked={cookiePreference === NO}
              onChange={() => setCookiePreferenceOption(NO)}
            />
          </WrapperOptions>
        </HeaderWrapper>

        <EmptySection>
          <StyledInfo>{formatMessage(messages.otherCookiesDescription)}</StyledInfo>
        </EmptySection>
        <EmptySection>
          <ButtonWrapper>
            <SavePreferencesButton
              role="button"
              disabled={areActionsDisabled}
              onClick={() => savePreferences(consentCookiesMutation)}
            >
              {savePreferenceButtonLoading ? (
                <Spinner color="white" size="20px" centerAbs centerX centerY />
              ) : (
                formatMessage(messages.savePreferences).toUpperCase()
              )}
            </SavePreferencesButton>
          </ButtonWrapper>
        </EmptySection>
        <StyledInfo>
          <FormattedMessage
            {...messages.changePreferences}
            values={{
              privacyPage: (
                <StyledLink onClick={goToPrivacyPage}>
                  <FormattedMessage {...messages.privacyPage} />
                </StyledLink>
              ),
              cookie: (
                <StyledLink href={PRIVACY_POLICY_URL} target="_blank">
                  <FormattedMessage {...messages.cookiePolicy} />
                </StyledLink>
              )
            }}
          />
        </StyledInfo>
      </ContentWrapper>
    );
  }
}
export default injectIntl(CookiePreferencesContent);
